import { CustomSnackBarModule } from "./components/custom-snack-bar/custom-snack-bar.module";
import { ConfirmModalModule } from "./components/confirm-modal/confirm-modal.module";
import { SidemenuModule } from "./components/sidemenu/sidemenu.module";
import { HeaderModule } from "./components/header/header.module";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { CdkStepperModule } from "@angular/cdk/stepper";
import { CdkTableModule } from "@angular/cdk/table";
import { CdkTreeModule } from "@angular/cdk/tree";
import { CpfCnpjPipeModule } from './components/pipe/cpf-cnpj-pipe.module';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatStepperModule } from "@angular/material/stepper";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSliderModule } from "@angular/material/slider";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTreeModule } from "@angular/material/tree";
import { PercentageMaskDirective } from "./components/directive/percentage-mask.directive";
import { CepPipeModule } from "./components/pipe/cep-pipe.module";
import { NgxMaskModule } from "ngx-mask";
import { AutocompleteGenericoModule } from "./components/generic-autocomplete/generic-autocomplete.module";
import { NgxCurrencyDirective } from "ngx-currency";
import { TruncateTextDirective } from "./components/directive/truncate-text.directive";
import { UppercaseDirective } from "./components/directive/upper-case.directive";
import { SimNaomModalModule } from "./components/sim-nao-modal/sim-nao-modal.module";
import { LowercaseDirective } from "./components/directive/lower-case.directive";
import { ReactiveFormsModule } from "@angular/forms";
import { ConfigService } from "./services/config/config-service";
import { GenericDatePickerModule } from "./components/generic-datepicker/generic-datepicker.module";
import { GenericDateTimePickerModule } from "./components/generic-datetimepicker/generic-datetimepicker.module";
import { AuditoriaLogButtonComponent } from "./components/auditoria-log-button/auditoria-log-button.component";

export function initializeApp(appConfig: ConfigService) {
  return () => appConfig.load();
}

@NgModule({
  declarations: [PercentageMaskDirective, TruncateTextDirective, UppercaseDirective, LowercaseDirective],
  imports: [CommonModule, HeaderModule, SidemenuModule,NgxCurrencyDirective], 
  exports: [
    HeaderModule,
    SidemenuModule,
    ConfirmModalModule,
    SimNaomModalModule,
    AutocompleteGenericoModule,
    GenericDatePickerModule,
    GenericDateTimePickerModule,
	  MatFormFieldModule,
    FlexLayoutModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatChipsModule,
    CustomSnackBarModule,
    CpfCnpjPipeModule,
    CepPipeModule,
    PercentageMaskDirective,
    NgxCurrencyDirective,
    NgxMaskModule,
    TruncateTextDirective,
    UppercaseDirective, 
    LowercaseDirective,
    ReactiveFormsModule,
  ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService], 
      multi: true
    }
  ],
})
export class SharedModule { }
